export const TOAST_DURATION_MS = 5000;
export const TOAST_MAX_WIDTH = 420;
export const TOAST_MAX_HEIGHT = 120;
export const TOAST_OFFSET_BELOW_HEADER = 15;

export const TOAST_TYPES = {
  WARNING: 'warning',
  ERROR: 'error',
  INFO: 'info'
};

export const TOAST_TYPE_STYLES = {
  [TOAST_TYPES.WARNING]: {
    backgroundColor: '#ff9807'
  },
  [TOAST_TYPES.ERROR]: {
    backgroundColor: 'rgb(235, 0, 0)'
  },
  [TOAST_TYPES.INFO]: {
    backgroundColor: 'rgb(20, 172, 0)'
  }
};
